import { z } from "zod";
import { schemes } from "../schema-validation";

export const invoicePaymentShareableLinksTokenPayloadSchema = z.object({
  companyID: schemes.companyID(),
  customerAccountID: schemes.uuid(),
  invoiceID: schemes.uuid(),
  isShareableLink: z.literal(true),
  testMode: z.boolean(),
  whiteLabelID: z.string(),
});

export const invoicePaymentInformationCompanySchema = z.object({
  company_id: schemes.companyID(),
  business_name: z.string(),
});

export const invoicePaymentInformationPayloadSchema = z.object({
  company: invoicePaymentInformationCompanySchema,
  logoURL: z.string().nullish(),
  tokenPayload: invoicePaymentShareableLinksTokenPayloadSchema,
});

export type TInvoicePaymentShareableLinksTokenPayload = z.infer<
  typeof invoicePaymentShareableLinksTokenPayloadSchema
>;
export type TInvoicePaymentInformationPayload = z.infer<
  typeof invoicePaymentInformationPayloadSchema
>;
